import { useTranslation } from 'next-i18next'

const MathMagicForUkraineTitle = (): React.ReactElement => {
  const { t } = useTranslation('donation')

  return (
    <h1 className="text-h4 md:text-h3 font-bold leading-10 tracking-wide text-center">
      <span className="bg-clip-text text-transparent bg-gradient-to-l from-purple via-pink-logo to-orange drop-shadow-lg">
        {t('mathMagicFor')}
      </span>
      <span className="text-blue-strong drop-shadow-lg"> {t('ukraine')} </span>
    </h1>
  )
}

export default MathMagicForUkraineTitle
